/* ==========================================================================
   Day nut doi so cot tren trang danh muc (kieu Kalles / seensense).
   Shrine khong co san tinh nang nay nen chen them bang JS.

   Cach hoat dong: doi class grid--N-col-desktop tren <ul id="product-grid">.
   Shrine da co san CSS cho 1..6 cot nen khong phai viet them layout.
   Lua chon duoc nho trong localStorage de lan sau vao van giu nguyen.
   ========================================================================== */
(function () {
  "use strict";

  var DESKTOP = [2, 3, 4, 5, 6];
  var MOBILE = [1, 2];
  var KEY_D = "kls-cols-desktop";
  var KEY_M = "kls-cols-mobile";

  function read(key, fallback) {
    try {
      var v = parseInt(localStorage.getItem(key), 10);
      return isNaN(v) ? fallback : v;
    } catch (e) {
      return fallback;
    }
  }

  function write(key, value) {
    try {
      localStorage.setItem(key, String(value));
    } catch (e) {
      /* che do rieng tu chan localStorage — bo qua, chi mat viec ghi nho */
    }
  }

  /* Icon: mot o vuong chua N thanh doc */
  function icon(n) {
    var w = 30;
    var h = 22;
    var pad = 3;
    var gap = 2;
    var inner = w - pad * 2;
    var bar = (inner - gap * (n - 1)) / n;
    var bars = "";
    for (var i = 0; i < n; i++) {
      bars +=
        '<rect x="' + (pad + i * (bar + gap)).toFixed(2) + '" y="' + pad +
        '" width="' + bar.toFixed(2) + '" height="' + (h - pad * 2) + '" rx="0.5"/>';
    }
    return (
      '<svg viewBox="0 0 ' + w + " " + h + '" aria-hidden="true" focusable="false">' +
      '<rect x="0.5" y="0.5" width="' + (w - 1) + '" height="' + (h - 1) +
      '" fill="none" stroke="currentColor" stroke-width="1.4"/>' + bars + "</svg>"
    );
  }

  function apply(grid, n, isMobile) {
    var prefix = isMobile ? "grid--" : "grid--";
    var suffix = isMobile ? "-col-tablet-down" : "-col-desktop";
    var list = isMobile ? MOBILE : DESKTOP;
    list.concat([1]).forEach(function (c) {
      grid.classList.remove(prefix + c + suffix);
    });
    grid.classList.add(prefix + n + suffix);
  }

  function build(container, grid) {
    var mobile = isMobile();
    var list = mobile ? MOBILE : DESKTOP;
    var key = mobile ? KEY_M : KEY_D;
    var current = read(key, mobile ? 2 : 4);
    if (list.indexOf(current) === -1) current = list[list.length - 1];

    var wrap = document.createElement("div");
    wrap.className = "kgs";
    wrap.setAttribute("role", "group");
    wrap.setAttribute("aria-label", "So san pham moi hang");
    wrap.dataset.mode = mobile ? "mb" : "dt";

    list.forEach(function (n) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "kgs__btn";
      btn.innerHTML = icon(n);
      btn.setAttribute("aria-label", n + " cot");
      btn.setAttribute("aria-pressed", n === current ? "true" : "false");
      btn.addEventListener("click", function () {
        apply(grid, n, mobile);
        write(key, n);
        wrap.querySelectorAll(".kgs__btn").forEach(function (b) {
          b.setAttribute("aria-pressed", "false");
        });
        btn.setAttribute("aria-pressed", "true");
      });
      wrap.appendChild(btn);
    });

    container.appendChild(wrap);
    apply(grid, current, mobile);
  }

  function isMobile() {
    return window.matchMedia("(max-width: 989px)").matches;
  }

  function init(force) {
    var container = document.querySelector(".facets-container");
    var grid = document.getElementById("product-grid");
    if (!container || !grid) return;
    var existing = container.querySelector(".kgs");
    if (existing) {
      /* Da co roi: chi dung lai khi vua doi giua dien thoai <-> may tinh */
      if (!force && existing.dataset.mode === (isMobile() ? "mb" : "dt")) return;
      existing.remove();
    }
    build(container, grid);
  }

  /* Doi khung man hinh thi so nut phai doi theo (dien thoai 2 nut, may tinh 5 nut) */
  var mq = window.matchMedia("(max-width: 989px)");
  if (mq.addEventListener) {
    mq.addEventListener("change", function () { init(true); });
  } else if (mq.addListener) {
    mq.addListener(function () { init(true); });
  }

  document.addEventListener("DOMContentLoaded", init);
  /* Shrine ve lai luoi khi loc/sap xep — dung lai nut sau moi lan ve lai */
  document.addEventListener("shopify:section:load", init);
  window.addEventListener("popstate", function () {
    setTimeout(init, 300);
  });
  var mo = new MutationObserver(function () {
    if (!document.querySelector(".facets-container .kgs")) init();
  });
  if (document.getElementById("ProductGridContainer")) {
    mo.observe(document.getElementById("ProductGridContainer"), { childList: true, subtree: false });
  }
})();
